/**
 * @generated SignedSource<<3fcdf24c5878a4f73b483ef87643b758>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubscriptionModal_subscribable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ResourceWithSubscription",
  "abstractKey": "__isResourceWithSubscription"
};

node.hash = "1f4f984e5df2da4533d529a98ea6d47d";

module.exports = node;
